<template>
    <div class="form__input__field" v-on:click="focus()" :class="{ error: (isValid == false), label: (label != '')}">
        <label class="form__label" :for="name">
            {{ label }}        </label>

        <input class="form__input" type="text" :id="name" :name="name" :placeholder="placeholder" v-model="inputField"
               ref="inputField"
               :required="required" :maxlength="limit>0 ? limit: false"/>
    </div>
</template>

<script>
    import InputField from "./InputField";

    export default {
        name: "FormInputField",
        extends: InputField
    }
</script>